export const CUSTOM_REMOVE_WATERMARK_CONTROL_ID = 'custom-remove-watermark-control';
export const CUSTOM_REMOVE_WATERMARK_CONTROL_MARGIN = 10;
export const REMOVE_WATERMARK_CONTROL_BORDER_RADIUS = '6px';

/**
 * Only used to place the pill on the very first render of a session, before it has been measured. Sized for the
 * English label; the real box is read from the DOM immediately after and cached, so a longer translation
 * corrects itself before paint rather than overflowing the item.
 */
export const REMOVE_WATERMARK_CONTROL_ESTIMATED_WIDTH = 150;
export const REMOVE_WATERMARK_CONTROL_ESTIMATED_HEIGHT = 32;

export interface RemoveWatermarkControlSize {
  width: number;
  height: number;
}
